// MEDIAS
document.addEventListener("DOMContentLoaded", function () {
	var main = new Splide("#main-slider", {
		type: "fade",
		rewind: true,
		pagination: false,
		arrows: false,
	});

	var zoom = new Splide("#zoom-slider", {
		type: "splide",
		rewind: true,
		pagination: false,
		arrows: true,
        gap: 20
	});

  var thumbnails = new Splide("#thumbnail-slider", {
		direction: "ttb",
		height: "100%",
		fixedWidth: 54,
		fixedHeight: 54,
		perPage: 10,
		gap: 8,
		rewind: true,
		pagination: false,
		isNavigation: true,
		arrows: false,
		breakpoints: {
			900: {
				type: "slide",
				direction: "ltr",
				rewind: false,
				isNavigation: false,
				autoWidth: true,
				arrows: true,
				fixedHeight: 275,
        perPage: 1,
      }
		},
  });

	main.sync(thumbnails);
	thumbnails.sync(zoom);
	main.mount();
	thumbnails.mount();
	zoom.mount();

  // ZOOM IMAGE
    // var image = document.getElementById('mmZoomMediaImage');
    // var imagePrev = document.getElementById('mmZoomPrev');
    // var imageNext = document.getElementById('mmZoomNext');

    // if (imagePrev != null) {
    //   imagePrev.addEventListener('click', function(e){
    //     console.log('prev');
    //     // get prev image src

    //     var nextImageSrc = document.querySelector('#thumbnail-slider .splide__slide.is-prev img').src;

    //     image.src = nextImageSrc;

    //     // Change slider index
    //     thumbnails.go( '<' );
    //   })

    // }


    // imageNext.addEventListener('click', function(e){
    //   console.log('next');
    //   var image = document.getElementById('mmZoomMediaImage');

    //   // get next image src
    //   var nextImageSrc = document.querySelector('#thumbnail-slider .splide__slide.is-next img').src;

    //   image.src = nextImageSrc;

    //   // Change slider index
    //   thumbnails.go( '>' );
    // })

});

//=== Form ===
// FORM
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest(".mm-product-form");

		this.addEventListener("change", this.onVariantChange);

		this.getSelectedOptions();
		this.getSelectedVariant();
		this.updateSizes();
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();
		this.updateSizes();

		if (this.currentVariant) {
			this.updateURL();
			this.updateMedia();
			this.variantFetch();
		}
	}

	updateURL() {
		if (!this.currentVariant) return;

		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	variantFetch() {
		let variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderVariantInfo(html) {
		this.updateElementOuter(".mm-variant_selected", html);
		this.updateMultipleElement(".mm-price", html);
		this.updateElementOuter(".mm-cta", html);
		this.updateElementOuter(".mm-product-form-variant-option.mm-option-Batteries", html);
		this.updateElement(".mm-option-taille-change", html);
		this.updateMultipleElement(".mm-pf-label-change", html);
	}
	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	updateMultipleElement(selector, html) {
		const destination = this.container.querySelectorAll(selector);
		const source = html.querySelectorAll(selector);

		if (source && destination) {
			for (let index = 0; index < source.length; index++) {
				destination[index].outerHTML = source[index].outerHTML;
			}
		}
	}

	getSelectedOptions() {
		if (this.dataset.select == "true") {
			this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox"), (checkbox) => checkbox.value);
		} else {
			this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
		}
	}

	updateSizes() {
		const availableSizes = this.variantData.filter((variant) => variant.option1 == this.options[0]);
		const sizeEl = this.querySelectorAll('.mm-product-form-variant-option.mm-option-Taille .mm-product-form-variant-value .mm-product-variant-checkbox');

		if (sizeEl.length > 0) {
			sizeEl.forEach(size => {
				const found = availableSizes.filter((variant) => variant.option2 == size.value);
				if (found.length > 0) {
					size.disabled = (found[0].available) ? false : true;
				}
			});
		}
	}

	getVariantJSON() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	updateMedia() {
		if (this.currentVariant.featured_media != null) {
			var mediaId = this.currentVariant.featured_media.id;
			var allMainMedia = document.querySelectorAll("#thumbnail-slider .splide__slide");
			allMainMedia.forEach((media) => {
				if (media.dataset.id != null && media.dataset.id == mediaId) {
					media.click();
				}
			});
		}
	}
}
customElements.define("variant-selector", VariantSelector);

document.addEventListener("DOMContentLoaded", function () {
  var btnSize = document.querySelector('.mm-cta-size');
  if (btnSize != null) {
    btnSize.querySelector(".mm-text-size").classList.remove('hidden');
    btnSize.querySelector(".mm-text-default").classList.add("hidden");
    btnSize.setAttribute('disabled', true);
  }
});


var optionTaille = document.querySelectorAll('input[name="options\[Taille\]"]');
optionTaille.forEach(function (input) {
  input.addEventListener("change", function () {
    var texts = document.querySelectorAll(".mm-change-text");
    if (this.checked) {
      texts.forEach(function (text) {
        if (text.classList.contains('no-size')) {
          text.classList.add('hidden');
        } else {
          text.classList.remove("hidden");
        }
      })
    }
  });
});

//CHANGE QTTY
function mmChangeQtty(delta, inputId) {
    var input = document.getElementById(inputId);
    if (delta == '-1' && input.value == '1') {} else {
        var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
        input.value = newValue;
        mmUpdatePrice(newValue);
    }
}
function mmUpdatePrice(qtty) {
    var priceAll = document.querySelectorAll('.mm-product-price-all');
    priceAll.forEach(function(price) {
        price.innerHTML = ((price.dataset.value * qtty) / 100).toFixed(2) + ' €';
    })
}
// STICKY CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var fixedCTA = document.getElementById("mm-fixed-btn");
var CTA = document.querySelector(".mm-bg-js-product-add");

function isInViewport(el) {
    const cta = el.getBoundingClientRect();
    return cta.bottom >= 104; // (104) Header + Announcement bar height
}

document.addEventListener(
    "scroll",
    function () {
        if (isInViewport(fixedCTA)) {
			CTA.classList.remove("mm-cta-sticky");
			document.querySelector('body').classList.remove("product-cta-sticky");
		} else {
			CTA.classList.add("mm-cta-sticky");
			document.querySelector('body').classList.add("product-cta-sticky");
		}
    },
    {
        passive: true,
    }
);

function mmOpenModalZoom(img) {
  var container = document.querySelector(".mm-pf-modal-zoom");
  var imgElement = container.querySelector('img');
  imgElement.src = '//gotheat.myshopify.com/cdn/shop/' + img;

  container.classList.remove('hidden');
}
function mmOpenModalZoomThumbnail(img) {
  if (window.innerWidth < 768) {
    // Faire quelque chose en mobile seulement
    var container = document.querySelector(".mm-pf-modal-zoom");
    var imgElement = container.querySelector('img');
    imgElement.src = '//gotheat.myshopify.com/cdn/shop/' + img;

    container.classList.remove('hidden');
  }
}
function mmCloseModalZoom() {
	var container = document.querySelector(".mm-pf-modal-zoom");
	container.classList.add("hidden");
}
